import React, { Component } from 'react'
import {
    Dialog,
    DialogActions,
    DialogContent,

    FormControl,
    Grid,
    Container,
    TextField,
} from '@material-ui/core'
import AppBarModal from '../../general/AppBarModal'
import { BtnForm } from '../../general/BotonesAccion';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

export default class AddPqrs extends Component {
    render() {
        let {
            modalAddPqrs,
            mostrarModalAddPqrs,
            enviarFormActual,

            onChangeState
        } = this.props
        return (
            <div>
                <ValidatorForm >
                    <Dialog open={modalAddPqrs} onClose={() => mostrarModalAddPqrs(false)} fullWidth={true} maxWidth="sm" fullScreen={window.innerWidth < 600}>
                        <AppBarModal titulo={"Crear PQRS"} mostrarModal={() => mostrarModalAddPqrs(false)} titulo_accion="" />
                        <DialogContent style={{ padding: 0, overflowX: 'hidden' }} >
                            <React.Fragment>
                                <FormControl className='form-control'>
                                    <Container maxWidth="sm">
                                        <Grid
                                            container
                                            spacing={3}
                                            direction='column'
                                            justify='center'
                                        >
                                            <Grid item xs={12}>
                                                <TextValidator
                                                    margin="dense"
                                                    id="titulo_pqrs"
                                                    label="Titulo"
                                                    type="text"
                                                    fullWidth
                                                    name="titulo_pqrs"
                                                    onChange={onChangeState}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    multiline
                                                    required
                                                    rows = { 5 }
                                                    id = 'body_pqrs'
                                                    name = 'body_pqrs'
                                                    label = 'PQRS'
                                                    fullWidth
                                                    onChange = { onChangeState }
                                                />
                                            </Grid>
                                        </Grid>
                                    </Container>
                                </FormControl>
                            </React.Fragment>
                        </DialogContent>
                        <DialogActions>
                            <BtnForm texto="CERRAR" callback={() => mostrarModalAddPqrs(false)} />
                            <BtnForm texto="GUARDAR" callback={() => enviarFormActual()} />
                        </DialogActions>
                    </Dialog>
                    <button type="submit" className='oculto' id='btn_crear_pqrs_portal'></button>
                </ValidatorForm>
            </div>
        )
    }
}